(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('UniversityConnectController', UniversityConnectController);

    UniversityConnectController.$inject = ['VirtualFairService'];

    function UniversityConnectController(VirtualFairService) {
        var vm = this;

        vm.flag                  = false;
        vm.expo                  = [];
        vm.expoSelected          = [];
        vm.selectExpo            = selectExpo;
        vm.users                 = [];
        vm.getByFilter           = getByFilter;
        vm.userTypeSelected      = {id: 'exhibitors', name : 'Exhibitors'};
        vm.userTypes             = [{id: 'exhibitors', name : 'Exhibitors'},{id: 'local_universities', name : 'Local Universities'}];

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        activate();

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function activate() {
            vm.selectExpo();
        }

        function selectExpo() {
            vm.query = {};
            vm.query['search'] = 'university_connect';
            vm.query['searchFields'] = 'type.type';

            VirtualFairService.all(vm.query).then(function(response){
                vm.expos = response.data;
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.query = {};
            vm.query['virtual_fair_id'] = vm.expoSelected.id;
            vm.query['user_type']       = vm.userTypeSelected.id;
            vm.query['page']            = vm.page;
            vm.flag                     = false;

            VirtualFairService.findByUniversityConnect(vm.query).then(function(response) {
                vm.flag = true;
                vm.users = response.data.userProfiles;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);

            }).catch(function(err) {
            });
        }
    }

})();